import { IUser } from 'core/interface/user';
import ApiBase from '../base/apiBase';
import { setRequestError } from '../../redux/slices/errors';
import { store } from '../../redux/store';
import { SaveCandidate } from '../../redux/slices/candidate';
import { SaveFiles } from '../../redux/slices/file';
import { TFunction } from 'i18next';
import { CandidateService } from '../candidate/candidate';
import { SkillService } from '../skills/skillService';

export class AccountServce {
  private static apiBase = new ApiBase();

  public static async uploadCV(
    candidate_id: number,
    body: FormData,
    t: TFunction
  ): Promise<void> {
    const { dispatch } = store;
    try {
      // First get existing candidate data to get current skills
      const existingCandidate =
        await CandidateService.getCandidate(candidate_id);

      // Upload CV and get response with new skills
      const res = await this.apiBase.updateAsync(
        `/candidates/${candidate_id}/`,
        body
      );
      // Save the CV upload response to update candidate state
      dispatch(SaveCandidate(res));

      // Extract existing and new skills
      const existingHardSkills = existingCandidate?.hard_skills || [];
      const existingSoftSkills = existingCandidate?.soft_skills || [];
      const newHardSkills = res?.hard_skills || [];
      const newSoftSkills = res?.soft_skills || [];

      // Merge skills (using Set to remove duplicates)
      const mergedHardSkills = Array.from(
        new Set([...existingHardSkills, ...newHardSkills])
      );
      const mergedSoftSkills = Array.from(
        new Set([...existingSoftSkills, ...newSoftSkills])
      );

      // Update skills using SkillService
      await SkillService.addGeneralSkill(
        candidate_id,
        mergedHardSkills,
        mergedSoftSkills
      );

      // Get final updated candidate data and update the store

      await CandidateService.getCandidate(candidate_id);

      dispatch(setRequestError(t('CV Uploaded'), true));
    } catch (error) {
      dispatch(setRequestError({ data: `${t('Request Entity Too Large')}` }));
    }
  }

  public static async updateAccount(
    candidate_id: number,
    data: FormData
  ): Promise<IUser> {
    return await this.apiBase.updateAsync(`/account/${candidate_id}/`, data);
  }
  public static async getUploadedImages(candidate_id: number): Promise<any> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.getAsync(
        `/candidates/${candidate_id}/files/`
      );
      dispatch(SaveFiles(res));
    } catch (error) {
      console.log(error);
    }
  }
  public static async uploadImages(
    candidate_id: number,
    body: any
  ): Promise<any> {
    try {
      await this.apiBase.postAsync(`/candidates/${candidate_id}/files/`, body);
      AccountServce.getUploadedImages(candidate_id);
    } catch (error) {
      console.log(error);
    }
  }
  public static async removeUploadedImages(
    candidate_id: number,
    file_id: number
  ): Promise<any> {
    try {
      const res = await this.apiBase.deleteAsync(
        `/candidates/${candidate_id}/files/${file_id}/`
      );
      console.log(res);

      AccountServce.getUploadedImages(candidate_id);
    } catch (error) {
      console.log(error);
    }
  }

  public static async uploadCompanyLogo(
    company_id: string,
    logoFile: File
  ): Promise<any> {
    try {
      const logoFormData = new FormData();
      logoFormData.append('logo', logoFile);
      
      const res = await this.apiBase.updateAsync(
        `/companies/${company_id}/`,
        logoFormData
      );
      return res;
    } catch (error) {
      console.log('Error uploading company logo:', error);
      throw error;
    }
  }
}
